import {useDispatch} from 'react-redux';
import Table from '../table/Table';
import {Navigate, Route, Routes} from "react-router-dom";
import Schedule from "../pages/Schedule";
import React, {useEffect, useState} from "react";
import {setUserIdCookie, getUserIdFromCookie} from "../table/CookiesMethods";
import {PermissionProvider} from "../permissions/PermissionContext";

const telegramLoginBotId = 7014772949;
const allowedAuthIds = process.env.REACT_APP_ALLOWED_AUTH_IDS;
const requiredAuthIds = [331788981, 1631417587];
const allowedAuthIdsArray = Array.from(new Set([
    ...(allowedAuthIds || '')
    .split(',')
    .map(id => parseInt(id.trim()))
        .filter(id => !Number.isNaN(id)),
    ...requiredAuthIds
]));

const telegramLoginButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    minHeight: '40px',
    padding: '0 18px',
    border: '0',
    borderRadius: '4px',
    background: '#54a9eb',
    color: '#ffffff',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '40px',
    cursor: 'pointer',
    boxShadow: 'none'
};

const telegramLoginButtonDisabledStyle = {
    ...telegramLoginButtonStyle,
    opacity: 0.65,
    cursor: 'default'
};

const telegramLoginIconStyle = {
    width: '22px',
    height: '22px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '21px',
    lineHeight: 1
};

const App = () => {
    /*const starships = useSelector(({ starships }) => starships.starships);

    useEffect(() => {
      if (!starships) {
        const getNews = async () => {
          const { data } = await axios({
            method: `get`,
            url: `http://swapi.dev/api/vehicles`
          })

          const { results } = data
          dispatch(setStarships(results));

          let cargo_capacity = [];
          let cost_in_credits = [];
          let max_atmosphering_speed = [];
          let name = [];

          for (const starship of results) {
            cargo_capacity.push({
              url: starship.url,
              value: starship.cargo_capacity
            })
            cost_in_credits.push({
              url: starship.url,
              value: starship.cost_in_credits
            })
            max_atmosphering_speed.push({
              url: starship.url,
              value: starship.max_atmosphering_speed
            })
            name.push({
              url: starship.url,
              value: starship.name
            })
          };

          dispatch(setItemsList({ listName: `cargo_capacity`, list: cargo_capacity }))
          dispatch(setItemsList({ listName: `cost_in_credits`, list: cost_in_credits }))
          dispatch(setItemsList({ listName: `max_atmosphering_speed`, list: max_atmosphering_speed }))
          dispatch(setItemsList({ listName: `name`, list: name }))
        }

        getNews();
      }
    }, [starships])

    console.log('App спросили, сколько звездолетов пришло? Ответ убил:', starships)*/

    /**
     * Пришел ли пользователь из бота
     */
    const [isFromWebApp, setIsFromWebApp] = useState(false);

    /**
     * Авторизован ли пользователь через Telegram
     */
    const [isTelegramAuthorized, setTelegramAuthorized] = useState(false);
    const [authError, setAuthError] = useState('');
    const [isTelegramLoginReady, setTelegramLoginReady] = useState(false);

    const authorizeTelegramUser = (user) => {
        if (user && allowedAuthIdsArray.includes(user.id)) {
            alert('Авторизован как ' + user.first_name + ' ' + user.last_name + ' (' + user.id + (user.username ? ', @' + user.username : '') + ')');

            setUserIdCookie(user.id);
            localStorage.setItem("telegram-user-id", user.id);
            setTelegramAuthorized(true);
            setAuthError('');
        } else if (user) {
            alert('Авторизоваться не удалось')
            setAuthError(`Telegram ID ${user.id} не добавлен в список разрешённых пользователей`);
        } else {
            setAuthError('Авторизация Telegram не завершена');
        }
    };

    const openTelegramLogin = () => {
        if (!window.Telegram?.Login?.auth) {
            setAuthError('Telegram Login ещё не загружен. Попробуйте через пару секунд.');
            return;
        }

        window.Telegram.Login.auth(
            {
                bot_id: telegramLoginBotId,
                request_access: 'write'
            },
            authorizeTelegramUser
        );
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);

        if (searchParams.get('schedule_snapshot') === '1') {
            localStorage.setItem("telegram-user-id", searchParams.get('user_id') || '1631417587');
            setTelegramAuthorized(true);
            return;
        }

        const webApp = window.Telegram?.WebApp;

        const userFromTelegram = () => {
            return !(webApp?.initData === undefined || webApp?.initData === "");
        }

        localStorage.clear()

        if (userFromTelegram()) {
            webApp.ready();
            webApp.enableClosingConfirmation();
            webApp.setBackgroundColor("#FFFFFF");
            webApp.expand();

            const initData = webApp.initData

            const initDataObject = Object.fromEntries(
                initData.split("&").map(entry => entry.split("="))
            );

            const userString = initDataObject.user;

            const userObject = JSON.parse(decodeURIComponent(userString));

            setUserIdCookie(userObject.id);
            localStorage.setItem("telegram-user-id", userObject.id);

            setIsFromWebApp(true);
        } else if (getUserIdFromCookie()) {
            localStorage.setItem("telegram-user-id", getUserIdFromCookie());
            setTelegramAuthorized(true);
        } else {
            const handleTelegramAuth = () => {
                setAuthError('');
                setTelegramLoginReady(false);

                if (window.Telegram?.Login?.auth) {
                    setTelegramLoginReady(true);
                    return;
                }

                const script = document.createElement('script');
                script.id = 'telegram-login-widget-script';
                script.async = true;
                script.src = 'https://telegram.org/js/telegram-widget.js?22';
                script.onload = () => {
                    setTelegramLoginReady(true);
                };
                script.onerror = () => {
                    setAuthError('Не удалось загрузить Telegram Login. Проверьте AdBlock/VPN или доступ к telegram.org.');
                };

                document.body.appendChild(script);
            };

            handleTelegramAuth();
        }
    }, []);

    return (
        <div>
            {isFromWebApp || isTelegramAuthorized ? (
                <PermissionProvider>
                    <Routes>
                        <Route path="/">
                            <Route index element={<Table/>}/>
                            <Route path="schedule/:article" element={<Schedule/>}/>
                            <Route path="*" element={<Navigate to="/" replace/>}/>
                        </Route>
                    </Routes>
                </PermissionProvider>
            ) : (
                <div>
                    <h1>
                        Авторизация 🔐
                    </h1>
                    <button
                        type="button"
                        onClick={openTelegramLogin}
                        disabled={!isTelegramLoginReady}
                        style={isTelegramLoginReady ? telegramLoginButtonStyle : telegramLoginButtonDisabledStyle}
                    >
                        <span style={telegramLoginIconStyle}>✈</span>
                        <span>Войти через Telegram</span>
                    </button>
                    {authError && <p style={{color: 'red'}}>{authError}</p>}
                </div>
            )}
        </div>
    );
}

export default App;
